import React from "react";
import { useEffect, useState } from "react";
import {
  Badge,
  Button,
  Card,
  Navbar,
  Nav,
  Table,
  Container,
  Row,
  Col,
  Modal,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import BonusCreateModal from "components/Bonus/BonusCreateModal";
import Nestable from "react-nestable";
import "./css/style.css";
import { useParams } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";
import API from "components/Apis/API";
import { useForm } from "react-hook-form";
import $ from "jquery"


const BonusOrgChart = () => {
  const { id } = useParams();
  const [Result, setResult] = useState([]);
  const [UnsortResult, setUnsortResult] = useState([]);
  const [Item, setItem] = useState({});


  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm();

  const fetchData = async () => {
    const toastId = toast.loading("Loading data...");

    const url = "admin/bonus/periods/" + id + "/result";

    const response = await API.getData(url);
    const data = response;
    if (data.status) {
      setResult(data.data.result);
    }

    toast.dismiss(toastId);
  };

  const updateRecord = async (id) => {
    const toastId = toast.loading("Updating data...");
    const url = "admin/bonus/result/" +id+ "/update_group";
    const formData = new FormData()
    formData.append('group', $("#group_"+id).val())
    formData.append('color', $("#color_"+id).val())

    const response = await API.postData(url,formData);
    const data = response;
    if (data.status) {
      setResult(data.data.result)
      ApplyStyle()
    }
    else
    {
      toast.error(data.msg)
    }

    toast.dismiss(toastId);
  };
  const calculateBonus = async () =>
    {
      const toastId = toast.loading("Saving data...")
      const url  = "admin/bonus/periods/"+id+"/calculate_bonus"
      const response  = await API.postData(url)
      if (response.status) {
        await fetchData()
      }
      toast.dismiss(toastId)
    }

  const showModal = async (item) =>
  {
    await setItem(item)
    handleShow()
  }

  const renderItem = ({ item }) => (
    <>
      <div className="result-item" data-color={item.group_color} style={{ marginTop: 0, marginBottom: 0 }}>
        {item.name}{" "}
   
        <select id={"group_"+item.id} onChange={()=>updateRecord(item.id)} value={item.group_name}>
          <option value="0">MEMBER</option>
          <option value="1">SOLO</option>
          <option value="2">GROUP</option>
          <option value="3">SUPERVISOR</option>
        </select>

        <input
          id={"color_"+item.id}
          name="group_color"
          type="color"
          defaultValue={item.group_color}
          style={{ width: "23px", height: "23px" }}
          onBlur={()=>updateRecord(item.id)}
        />

        
        <p style={{ fontSize: "13px" }}>
          <strong>Total Gross Margin: </strong>
          {item.c_revenue} |&nbsp;
          <strong>Gross Margin: </strong>
          {item.revenue} |&nbsp;
          <strong>Team Gross Margin: </strong>
          {item.c_revenue} |&nbsp;
          <strong>Failure: </strong>
          {item.failure_amount} |&nbsp;
          <strong>Team Failure: </strong>
          {item.c_failure_amount} |&nbsp;
          <strong>Final Bonus: </strong>
          {item.final_bonus}
        </p>
        <div className="sortable-right" style={{ float: "right" }}></div>
      </div>
    </>
  );

  const confirmChange = async (props) => {
    const toastId = toast.loading("Loading data...");
    const url = "admin/bonus/periods/" + id + "/result/sort";
    let formData = new FormData();
    formData.append("data", JSON.stringify(props));
    const response = await API.postData(url, formData);
    const data = response;
    setResult(data.data.result);
    toast.dismiss(toastId);
    ApplyStyle()
  };


  const ApplyStyle = ()=>
    {
      $(document).ready(function () {
        
        $(".result-item").each(function () {
          const color = $(this).data('color');
          $(this).parent().parent().removeAttr('style');
          $(this).parent().parent().css('border', `2px solid ${color}`);
        });
      });
    }
  useEffect(() => {
    const fetchDataAndApplyStyle = async () => {
      // Perform async data fetching
      await fetchData();

      // Apply styles using jQuery
      ApplyStyle()
    };

    fetchDataAndApplyStyle();

    // Cleanup function when component unmounts
    return () => {
      $(".result-item").each(function () {
        $(this).parent().parent().removeAttr('style');
      });
    };
  }, []); 





  return (
    <>
      <Toaster position="bottom-right" />
      <Container fluid>
        <Row>
          <Col md="12">
            <Card className="strpied-tabled-with-hover">
              <Card.Header>
                <Card.Title as="h4">
                  Manage Organization Chart
                  <Link
                    className="btn btn-primary btn-sm tbtn terminal_1"
                    style={{ margin: "5px", float: "right" }}
                    to={`/admin/app/bonus-manage/${id}`}
                  >
                    Go Back
                  </Link>
                  <a style={{ margin: "5px", float: "right" }} className="btn btn-primary btn-sm" onClick={()=>calculateBonus()}>Calculate Bonus</a>

                </Card.Title>
                <p className="card-category">
                  Create and manage organization charts
                </p>
              </Card.Header>
              <Card.Body className="">
                <Row>
                  <Col md="12">
                    <Nestable
                      items={Result}
                      renderItem={renderItem}
                      onChange={confirmChange}
                    />
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>

      <Modal show={show} onHide={handleClose} className=" bd-example-modal-lg">
        <form onSubmit={handleSubmit(updateRecord)} className="group-form">
          <Modal.Header>
            <Modal.Title style={{ width: "100%", margin: "0 0 0" }}>
              Update Record
            </Modal.Title>
          </Modal.Header>

          <Modal.Body style={{ paddingTop: "10px" }}>
            <table className="table table-stripped">
              <thead></thead>
              <tbody>
                <tr>
                  <th>Group Name</th>
                  <td>
                    <input
                      name="group_name"
                      type="text"
                      className="form-control mt-1 modalInput"
                      placeholder="Enter group name eg. Night Shift"
                      
                      defaultValue={Item.group_name}
                    />
                  </td>
                </tr>
                <tr>
                  <th>Group Color</th>
                  <td>
                    <input
                      name="group_color"
                      type="color"
                      className="form-control mt-1 modalInput"
                      placeholder="Choose a color for this group"
                      required
                      defaultValue={Item.group_color}
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Close
            </Button>
            <Button variant="primary" type="submit">
              Save Changes
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
    </>
  );
};

export default BonusOrgChart;
